import { Link } from 'react-router-dom';
import { CalendarX, ChevronRight, FileSpreadsheet } from 'lucide-react';
import { NewBadge } from '../components/NewBadge';

// The Reports tab: one card per report. A new report is a page plus a line here.

const REPORTS = [
  {
    name: 'Tariff Usage Report by NMI',
    href: '/bill-validation/report-hub/tariff-usage',
    icon: CalendarX,
    description: 'Months and days with no interval data: one NMI, or every site in a period (Bulk).',
    isNew: true,
  },
  {
    name: 'NEM12 Interval Export',
    href: '/bill-validation/report-hub/interval-export',
    icon: FileSpreadsheet,
    description: 'Interval data as CSV, or XLSX with a monthly demand profile, from stored data or a NEM12 file.',
    isNew: true,
  },
];

export const ReportsHubPage = () => (
  <div className="p-6 space-y-4">
    <div>
      <h1 className="text-xl font-semibold text-gray-900">Reports</h1>
      <p className="text-sm text-gray-500">Pick a report to run.</p>
    </div>
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {REPORTS.map((r) => (
        <Link
          key={r.href}
          to={r.href}
          data-testid="report-card"
          className="group flex items-start gap-3 rounded-lg border bg-white p-4 hover:border-blue-300 hover:bg-blue-50/40"
        >
          <r.icon className="mt-0.5 h-5 w-5 shrink-0 text-blue-600" />
          <div className="flex-1">
            <p className="flex items-center gap-2 font-medium text-gray-900">{r.name} {r.isNew && <NewBadge />}</p>
            <p className="text-sm text-gray-500">{r.description}</p>
          </div>
          <ChevronRight className="h-4 w-4 text-gray-400 group-hover:text-blue-600" />
        </Link>
      ))}
    </div>
  </div>
);
